import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { format } from "date-fns";
import { CircularProgress } from "@mui/material";
import QuotationListFilterModal from "./QuotationListFilterModal";
import ic_filter from "../utils/ic_filter.png";
import useApi from "../hooks/useApi";
import PaginationControls from "../components/lead_and_quotation/PaginationControls";
import ReusableTable from "../components/lead_and_quotation/TableListViewFull";
import QuotationDetailsPopup from "../components/lead_and_quotation/QuotationDetailsPopup";

const SampleApprovalListViewFull = (props) => {
  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  const todayDate = format(new Date(), "yyyy-MM-dd");

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

  const userAccessGroup = currentUserObject[0].accessgrp;

  const initialFilterObject = {
    fromDate: "1900-01-01",
    toDate: todayDate,
    task_creator_id:
      userAccessGroup?.trim().toUpperCase() === "COORDINATOR"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    task_owner_id:
      userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
      userAccessGroup?.trim().toUpperCase() != "ADMIN"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    free_text: "-",
  };

  const [showLeadFilter, setShowLeadFilter] = useState(false);
  const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [quotationList, setQuotationList] = useState(null);
  const [quotationDetailsData, setQuotationDetailsData] = useState(null);
  const [quotationDetailsPopup, setQuotationDetailsPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (currentPageNumber) {
      console.log("currentPageNumber ", currentPageNumber);

      const currentUserDepartment = localStorage.getItem(
        "currentSelectedDepartment"
      );
      const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
      const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

      if (!currentUserObject) {
        console.error("No user data found in localStorage");
        return;
      }

      const userAccessGroup = currentUserObject[0].accessgrp;

      console.log("currentUserDepartment:", currentUserDepartment);
      console.log("userAccessGroup:", userAccessGroup);

      fetchQuotationList(
        userAccessGroup,
        currentUserDepartment,
        initialFilterObject,
        empIDFromUserObjectInLocalStorage
      );
    }
  }, [currentPageNumber]);

  const {
    request: requestQuotationList,
    // loading: loadingQuotationList,
    error,
  } = useApi();
  const fetchQuotationList = async (
    userAccessGroup,
    currentUserDepartment,
    filterObjectFromModal,
    empIDFromUserObjectInLocalStorage
  ) => {
    console.log("filterObjectFrom Modal", filterObjectFromModal);

    setLoading(true);

    try {
      let url = "";

      if (
        userAccessGroup?.trim().toUpperCase() === "ADMIN" ||
        userAccessGroup?.trim().toUpperCase() === "CADMIN" ||
        userAccessGroup?.trim().toUpperCase() === "CACCOUNTS" ||
        userAccessGroup?.trim().toUpperCase() === "C ACC JUNIOR"
      ) {
        url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/SAMPLEAPPROVAL/-/${currentUserDepartment}`;
      }

      const response = await requestQuotationList({
        url: url,
        method: "GET",
        timeout: 5000,
      });
      console.log("Quotation List:", response);
      setQuotationList(response);
    } catch (error) {
      console.error("Error fetching quotations:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {};

  useEffect(() => {
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroup = currentUserObject[0].accessgrp;
    setCurrentUserGroupAccess(userAccessGroup);
  }, []);

  const {
    request: requestChangeStatus,
    loading: loadingChangeStatus,
    error: errorChangeStatus,
  } = useApi();
  const callAPIToChangeStatus = async (quot_slNo, statusByAdmin) => {
    const currentUserDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    );

    const currentUserfromLocalStorage = JSON.parse(
      localStorage.getItem("currentUser")
    );

    let currentUserEMPID = "-";

    if (currentUserfromLocalStorage) {
      console.log(
        "currentUserfromLocalStorage[0] ",
        currentUserfromLocalStorage[0]
      );
      currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
    } else {
      console.log(
        "currentUserfromLocalStorage[0] else",
        currentUserfromLocalStorage[0]
      );
    }

    const jsonObject = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "SAMPLEAPPROVAL",
        DocNo: quot_slNo,
        deptno: currentUserDepartment,
        Status: statusByAdmin,
        Comments: "",
        UserID: currentUserEMPID?.trim(),
        created_on: format(new Date(), "yyyy-MM-dd"),
      },
    ];

    const jsonToSend = JSON.stringify(jsonObject);

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/ProposalStatus`;

    try {
      const response = await requestChangeStatus({
        url: apiUrl,
        method: "POST",
        data: jsonToSend,
        config: {
          headers: {
            "Content-Type": "application/json",
          },
        },
        timeout: 5000,
      });
      if (response.result === "Saved") {
        alert("Saved");
      } else {
        alert("Something went wrong");
      }
    } catch (err) {
      console.log("Error", err);
    }
  };

  //   const goToAdminSalesOrderDetails = (clickedListItem) => {

  //     // let selectedLead = {
  //     //   ...clickedListItem,
  //     //   lead_id: clickedListItem.Lead_ID,
  //     //   lead_organization: clickedListItem.Customer,
  //     //   lead_account: clickedListItem.Account,
  //     //   lead_salesperson: clickedListItem.Sales_Person,
  //     //   lead_coordinator: clickedListItem.Coordinator,
  //     //   deptno: clickedListItem.Dept
  //     // }
  //     // console.log("selectedLead>>> Admin List", selectedLead)

  //     // navigate(`/sales_order_details_admin`, { state: { selectedLead } })

  //     callAPIToChangeStatus()

  //   }

  const goToUserSalesOrderDetails = (clickedListItem) => {
    let selectedLead = {
      ...clickedListItem,
      lead_id: clickedListItem.Lead_ID,
      lead_organization: clickedListItem.Customer,
      lead_coordinator: clickedListItem.Coordinator,
      lead_salesperson: clickedListItem.Sales_Person,
      lead_account: clickedListItem.Account,
      deptno: clickedListItem.Dept,
    };
    console.log("selectedLead>>>", selectedLead);

    navigate("/sales_order_details_user", { state: { selectedLead } });
  };
  const quotationSampleConfig = {
    columns: [
      { header: "Quotation Number", accessor: "Proposal_No" },
      { header: "Date", accessor: "Date", type: "date" },
      { header: "LPO No.", accessor: "so_ref" },
      { header: "Customer Name", accessor: "Customer", trim: true },
      { header: "Customer Account", accessor: "Cust_Acc" },
      { header: "Code", accessor: "Code" },
      { header: "Description", accessor: "Description" },
      { header: "Salesperson", accessor: "Salesperson", trim: true },
      { header: "Sample Qty", accessor: "Sample_Qty" },
      { header: "Status", accessor: "Status", type: "status" },
      {
        header: "Action",
        type: "actions",
        headerClassName: "text-center w-[240px]",
        actions: [
          {
            label: "Approve",
            className:
              "bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded text-xs",
            onClick: (item) =>
              callAPIToChangeStatus(item.quot_slNo, "Approved"),
          },
          {
            label: "Reject",
            className:
              "bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded text-xs",
            onClick: (item) =>
              callAPIToChangeStatus(item.quot_slNo, "Rejected"),
          },
        ],
      },
    ],
  };

  return (
    <div className=" lg:px-6 px-3 overflow-x-auto lg:w-full w-[100vw]">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-normal text-gray-800 ">
          Sample Request List
        </h3>
        <PaginationControls
          setCurrentPageNumber={setCurrentPageNumber}
          currentPageNumber={currentPageNumber}
          data={quotationList}
          itemsPerPage={100}
        />
      </div>

      <div className="w-full overflow-x-auto">
        <ReusableTable
          data={quotationList}
          columns={quotationSampleConfig.columns}
          currentUserAccessGroup={currentUserAccessGroup}
        />
      </div>
      {loading ? (
        <p className="inset-0 fixed flex justify-center items-center">
          Loading quotations... <CircularProgress size={24} />
        </p> // Show loader while fetching
      ) : (
        <ul>
          {/* {quotationList?.map((quote, index) => (
            <li key={index}>{quote.name}</li>
          ))} */}
        </ul>
      )}

      {showLeadFilter && (
        <QuotationListFilterModal
          applyFilters={applyFilters}
          closeFilter={() => setShowLeadFilter(false)}
          fetchQuotationList={fetchQuotationList}
        />
      )}
    </div>
  );
};

export default SampleApprovalListViewFull;
